import * as DictionaryConstants from '../../../../../../constants/DictionaryConstants'
import * as RoutePathConstants from '../../../../../../constants/RoutePathConstants'

export default {
  data () {
    return {

    }
  },
  methods: {

    submit () {
      this.$message.success('一键续保成功!')
      setTimeout(this.$router.go(-1), 3000)
    }
  },
  mounted () {
    document.title = '一键续保'
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/page-mail-service/views/one-click-renewal/one-click-renewal.js